import { render, staticRenderFns } from "./paymentaccount.vue?vue&type=template&id=9c0bbfbe&scoped=true"
import script from "./paymentaccount.vue?vue&type=script&lang=js"
export * from "./paymentaccount.vue?vue&type=script&lang=js"
import style0 from "./paymentaccount.vue?vue&type=style&index=0&id=9c0bbfbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c0bbfbe",
  null
  
)

export default component.exports